import getLogger, { LOGGER_NAME } from '../../../helpers/logging';

const logger = getLogger(LOGGER_NAME.NAV);

export default logger;
